import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import PlusMinus from './plusMinus.jsx';
import Dropdown from 'react-dropdown';

class CustomGameSettingsView extends React.Component {

    constructor(props) {
        super(props);
         
        this.state = {
            custom: false
        }
    }

    clickCustom() {
        this.setState({custom: !this.state.custom});
    }

    genNumberUpDown(name, valueContainer) {

        const me = this;
        const setValue = function(value) {

            if (value > valueContainer.max)
                value = valueContainer.max;
            if (value < valueContainer.min)
                value = valueContainer.min;
            valueContainer.value = value;
            me.props.reRender();
        }

        return (
            <div>
                <span class="settingsTextContainer">{name}</span> <span><PlusMinus jumpBy={valueContainer.jumpBy} setValue={setValue} value={valueContainer.value}/></span>
            </div>
        );
    }

    genMapEvent(name, valueContainer) {

        if (!valueContainer) {
            console.log("Huh?", name);
            return;
        }  

        const me = this;
        const onChange = function(value) {

            value = value.value;
            if (value == "none")
                valueContainer.value = 0;
            else if (value == "normal")
                valueContainer.value = 1;
            else
                valueContainer.value = 2;
            me.props.reRender();
        }

        const options = [
          'none', 'normal', 'lots'
        ];
        const defaultOption = valueContainer.value == 0 ? "none" : valueContainer.value == 1 ? "normal" : "lots";
        
        return (
            <div class="mapEventSettings">
                {name} <span class="dropdownContainer"><Dropdown menuClassName="dropDownMenuClass" options={options} onChange={onChange} value={defaultOption} placeholder="normal" /></span>
            </div>
        );
    }

    genPowerupList() {

        const me = this;
        const listOfDivs = [[],[],[]];

        let i = 0;
        for (let name of this.props.customGameSettings.powerupNames) {

            const onChange = function() {
                me.props.customGameSettings.powerupsDisabled[name] = !me.props.customGameSettings.powerupsDisabled[name];
                me.props.reRender();
            }

            if (this.props.customGameSettings.powerups.value == 0 && false) {
                listOfDivs[i].push(
                    <div class="customGameSettingsCheckboxContainer">
                        <span class="customGameSettingsCheckboxContainerInner">
                            { this.props.customGameSettings.powerupsDisabled[name] && <input type="checkbox" id={name} name={name} onChange={onChange} disabled/> }
                            { !this.props.customGameSettings.powerupsDisabled[name] && <input type="checkbox" id={name} name={name} onChange={onChange} disabled checked/> }
                            <label for={name}>{name}</label>
                        </span>
                    </div>
                );
            } else {
                listOfDivs[i].push(
                    <div class="customGameSettingsCheckboxContainer" onClick={onChange}>
                        <span class="customGameSettingsCheckboxContainerInner">
                            { this.props.customGameSettings.powerupsDisabled[name] && <input type="checkbox" id={name} name={name} onChange={onChange}/> }
                            { !this.props.customGameSettings.powerupsDisabled[name] && <input type="checkbox" id={name} name={name} onChange={onChange} checked/> }
                            <label for={name}>{name}</label>
                        </span>
                    </div>
                );
            }

            if (++i > 2)
                i = 0
        }  

        return (
            <table>
                <tbody>
                    <tr style={{backgroundColor: "black", textAlign: "right"}}>
                        <td style={{width: "33%", textAlign: "left"}}> { listOfDivs[0] } </td>
                        <td style={{width: "33%", textAlign: "left"}}> { listOfDivs[1] } </td>
                        <td style={{width: "33%", textAlign: "left"}}> { listOfDivs[2] } </td>
                    </tr>
                </tbody>
            </table>
        )
    }
    
    clickPowerupList() {
        window.open("https://traitors.sh/resources/list.html", "_blank");
    }

    render() {

        return (
            <div class="darkBack">
            
                <div class="tutorialPrivacyPopup2" style={{marginTop: "37px"}}>
                    <h3>
                        Custom Game Settings:<br/>
                    </h3>
                    <table>
                        <tbody>
                            <tr style={{backgroundColor: "black", textAlign: "right"}}>
                                <td>
                                    { this.genNumberUpDown("Wins:", this.props.customGameSettings.maxWins) }
                                    { this.genNumberUpDown("Bullets:", this.props.customGameSettings.maxBullets) }
                                    { this.genNumberUpDown("Time Until Walls Close In (seconds):", this.props.customGameSettings.walls) }
                                    { this.genNumberUpDown("Reveal Timer (seconds):", this.props.customGameSettings.revealTimer) }
                                </td>
                                <td>
                                    { this.genMapEvent("Death Zones", this.props.customGameSettings.deathZones) }
                                    { this.genMapEvent("Mini Death Zones", this.props.customGameSettings.miniDeathZones) }
                                    { this.genMapEvent("Scan Bars", this.props.customGameSettings.scanBars) }
                                    { this.genMapEvent("Invis Fields", this.props.customGameSettings.invisFields) }
                                    { this.genMapEvent("Powerups", this.props.customGameSettings.powerups) }
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="customGamePowerups" onClick={this.clickPowerupList}>
                        Powerup Descriptions >>
                    </div>

                    { this.genPowerupList() }
                    <br/><br/>
                    <button style={{border: "1px solid black"}} onClick={this.props.resetToDefault}>Reset to Default</button>
                    <span style={{padding: "14px"}}/>
                    <button style={{border: "1px solid black"}} onClick={this.props.clickSettings}>Done</button>
                </div>
            </div>
        ); //'
    }
}

CustomGameSettingsView.propTypes = {
    resetToDefault: PropTypes.func,
    clickSettings: PropTypes.func,
    reRender: PropTypes.func,
};

export default CustomGameSettingsView;